
export const getIcon = (name: any) => {
    let imgData
    try {
        imgData = require(`@/assets/blockchain-icons/${(name).toLowerCase()}.svg`)
    } catch (error) {
        imgData = `https://static.scorechain.com/public-storage/blockchain/${(name).toLowerCase()}.svg`
    }
    return imgData
}
